export default {
  pagination: {},
  module: {},
  modules: [],
  selectedModule: {}
};
